import { render } from "./NewWhale.vue?vue&type=template&id=655a952e"
import script from "./NewWhale.vue?vue&type=script&lang=js"
export * from "./NewWhale.vue?vue&type=script&lang=js"

import "./NewWhale.vue?vue&type=style&index=0&id=655a952e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__